import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { PlusOutlined } from "@ant-design/icons";
import { useNavModel } from "@/model/navModel";
import { assetsArchivesModel } from "../assetsArchivesModel";
import { globalPrompt } from "@/components/message";

export const DataBox = () => {
    const { selectedRowKeys, loadData } = assetsArchivesModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const exportData = () => {
       
    }



    return (
        <YhBox title=""  style={{height:'calc(100vh - 200px)'}}>
            <DataTable />
        </YhBox>
    )
}
